import ConfirmModalView from './ConfirmModalView';
import ConfirmModalAltView from './ConfirmModalAltView';

import { IConfirmModal } from './interfaces';

const ConfirmModal = ({
  icon,
  title,
  message,
  open,
  onCancel,
  onConfirm,
  onClose,
  confirmButtonName,
  cancelButtonName,
  onCancelAltAction,
  isConfirmLoading = false,
  isCancelLoading = false,
  altStyling = false,
  hideCloseButton = false,
  children,
  sx = {},
}: IConfirmModal) => {
  return (
    <>
      {altStyling && (
        <ConfirmModalAltView
          icon={icon}
          title={title}
          message={message}
          open={open}
          onCancel={onCancel}
          onConfirm={onConfirm}
          confirmButtonName={confirmButtonName}
          cancelButtonName={cancelButtonName}
          onCancelAltAction={onCancelAltAction}
          hideCloseButton={hideCloseButton}
          sx={sx}
        >
          {children}
        </ConfirmModalAltView>
      )}
      {!altStyling && (
        <ConfirmModalView
          icon={icon}
          title={title}
          message={message}
          open={open}
          onCancel={onCancel}
          onClose={onClose}
          onConfirm={onConfirm}
          confirmButtonName={confirmButtonName}
          cancelButtonName={cancelButtonName}
          isConfirmLoading={isConfirmLoading}
          isCancelLoading={isCancelLoading}
          sx={sx}
        />
      )}
    </>
  );
};

export default ConfirmModal;
